<template>
  <div
    class="content-slide-ppt-wrp"
    :class="{'content-slide-ppt-wrp-white-bg' : !isWhiteLabel}"
  >
    <div
      v-if="!isWhiteLabel"
      class="link-ppt-addin"
      v-tooltip="{
        content: tooltip,
        show: isShowTooltip,
      }"
      @mouseover="hoverTooltipHandler()"
      @mouseleave="leaveTooltipHandle()"
      @click="openPPTModal"
    >
      <img src="@/assets/images/ppt/ppt-addin-icon.svg">
      <span class="ml-1 mr-1">{{ $i18nPresenter.t('Add to PowerPoint') }}</span>
      <div class="beta-badge">
        {{ $i18nPresenter.t('Beta') }}
      </div>
    </div>
    <AddInPPTModal
      v-if="showModalPPT"
      @hide="hidePPTModal"
      @done="donePPTModal"
      :slideType="slideType"
      :type="type"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AddInPPTModal from '@/components-v2/modals/AddInPPTModal.vue'
import Util from '@/util'
import constants from '@/constant'

const { eventCategories } = constants

export default {
  components: {
    AddInPPTModal,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    slideType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showModalPPT: false,
      tooltip: '',
      isShowTooltip: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    isWhiteLabel() {
      return Util.checkWhiteLabelDomain()
    },
  },
  watch: {
    '$store.state.slideActive': {
      handler(newVal) {
        const { type, slideType } = newVal
        const slideName = Util.getCorrectSlideTypeName(type, slideType)
        const tooltipName = {
          poll: 'Poll',
          pickAnswer: 'Quiz',
          wordCloud: 'Word Cloud',
          pickImage: 'Quiz',
          'q&a': 'Q&A',
          leaderboard: 'Leaderboard',
          spinnerWheel: 'Spinner Wheel',
        }
        if (tooltipName[slideName]) {
          const text = this.getTooltipLocalizeText(tooltipName[slideName])
          this.tooltip = `<div>
            <div>
              <span style="font-family: 'Nunito';"><b>${text}</b></span>
            </div>
            </div>`
        } else {
          this.tooltip = ''
        }
      },
      immediate: true,
    },
    $route: {
      handler(to) {
        const { presenting = false, preview = false } = to.query
        if (presenting || preview) {
          this.tooltip = ''
        }
      },
    },
  },
  mounted() {
    this.showModalPPT = false
  },
  methods: {
    getTooltipLocalizeText(name) {
      const text = `Run this ${name} in PowerPoint!`
      if (this.$i18nPresenter) {
        return this.$i18nPresenter.t('runThisXInPowerPoint', {
          name,
        })
      }
      return text
    },
    openPPTModal() {
      this.showModalPPT = true
      const slideName = Util.getCorrectSlideTypeName(this.type, this.slideType)
      Util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Open modal', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    hidePPTModal() {
      this.showModalPPT = false
      const slideName = Util.getCorrectSlideTypeName(this.type, this.slideType)
      Util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Close modal', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    donePPTModal() {
      this.showModalPPT = false
      const slideName = Util.getCorrectSlideTypeName(this.type, this.slideType)
      Util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Add to PowerPoint > Done', null, null, {
        slideType: slideName,
        type: this.type,
      })
    },
    hoverTooltipHandler() {
      this.isShowTooltip = true
    },
    leaveTooltipHandle() {
      this.isShowTooltip = false
    },
  },
}
</script>

<style lang="scss" scoped>
.content-slide-ppt-wrp {
  min-height: 51px;
  display: flex;
  @apply items-center justify-between pl-5 pr-5;
}
.content-slide-ppt-wrp-white-bg {
  background: #fff;
}
.link-ppt-addin {
  display: flex;
  padding: 8px;
  @apply whitespace-nowrap w-max justify-end;
  @apply cursor-pointer font-bold items-center rounded hover:bg-secondary-15;
}
.beta-badge {
  background-color: #FFB12E;
  border-radius: 4px;
  color: #ffffff;
  font-size: 9px;
  line-height: 16px;
  padding: 0px 4px;
  height: 16px;
  margin-left: 2px;
}
</style>
